module.exports = __webpack_public_path__ + "img/1x.adf59a5.jpg";